import moment from "moment";
moment.locale("es");

export function fechaBagno(date) {
  const mdate = moment(date);
  const day_of_year = mdate.dayOfYear();
  const week_of_year = mdate.week();
  const year = mdate.year().toString().slice(-2);
  return week_of_year + "-" + day_of_year + "-" + year;
}
